class Validator {
  // Static method for required validation
  static validateRequired(value, validationFn) {
    value = value.trim();
    return validationFn(value);
  }

  // Static method for optional validation
  static validateOptional(value, validationFn) {
    value = value.trim();
    if (value === "") {
      return true;
    }
    return validationFn(value);
  }

  #isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  #isValidBrand(brandName) {
    return brandName.length > 0;
  }

  #isValidLargeTextField(largeTextField) {
    return largeTextField.length > 0;
  }

  #isValidCountry(country) {
    return country.length > 0;
  }

  #isValidKeyword(keyword) {
    return keyword.length > 0;
  }

  // Static method to validate URL using private method
  static validateUrl(url) {
    const instance = new Validator();
    return instance.#isValidUrl(url);
  }

  // Static method to validate Brand Name using private method
  static validateBrandName(brandName) {
    const instance = new Validator();
    return instance.#isValidBrand(brandName);
  }

  static validateLargeTextField(largeTextField) {
    const instance = new Validator();
    return instance.#isValidLargeTextField(largeTextField);
  }
  static validateCountry(country) {
    const instance = new Validator();
    return instance.#isValidCountry(country);
  }
  static validateSingleKeyword(keyword) {
    const instance = new Validator();
    return instance.#isValidKeyword(keyword);
  }
}
export default Validator;
